// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import "babel-polyfill"
import http from './http';

Vue.prototype.$axios = http;
// http.defaults.baseURL = '/api'  //自动附加在所有axios请求前面，则可以省略/api，直接写'/xxxx/xxx'。否则需要设置'/api/xxxx/xxx'
http.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'api' : process.env.API_HOST


// require styles
Vue.use(ElementUI);
import SafeHtml from './directives/safeHtml'
Vue.use(SafeHtml)
import VueAMap from 'vue-amap';
Vue.use(VueAMap)
// 初始化vue-amap
VueAMap.initAMapApiLoader({
  key: 'f53f31e78c72b8688ae71146bf3e9ef1',
  // 插件集合 （插件按需引入）
  plugin: [
      "AMap.Autocomplete", //输入提示插件
      "AMap.PlaceSearch", //POI搜索插件
      "AMap.Scale", //右下角缩略图插件 比例尺
      "AMap.OverView", //地图鹰眼插件
      "AMap.ToolBar", //地图工具条
      "AMap.MapType", //类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
      "AMap.PolyEditor", //编辑 折线多，边形
      "AMap.CircleEditor", //圆形编辑器插件
      "AMap.Geolocation", //定位控件，用来获取和展示用户主机所在的经纬度位置
      "AMap.MarkerClusterer" //定位控件，用来获取和展示用户主机所在的经纬度位置
  ]
});
// import '../static/js/keyBoard.js'
Vue.config.productionTip = false
Vue.prototype.$baseUrl = process.env.baseUrl
import "./assets/css/common.css"
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js